<template>
  <div class="wrapper">
    <div class="van-nav-bar">通用链接测试</div>
    <section class="van-doc-demo-block">
      <h2 class="van-doc-demo-block__title">app环境</h2>
      <van-radio-group v-model="appType">
        <van-cell-group>
          <van-cell title="Bee语音" clickable @click="appType = 1">
            <van-radio slot="right-icon" :name="1"/>
          </van-cell>
          <van-cell title="乐视视频语音版" clickable @click="appType = 2">
            <van-radio slot="right-icon" :name="2"/>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </section>
    <section class="van-doc-demo-block">
      <h2 class="van-doc-demo-block__title">打开首页</h2>
      <van-cell-group>
        <van-field
          center
          clearable
          label="无参数"
          :border="false"
          disabled
          use-button-slot>
          <div class="button-box" slot="button">
            <van-button slot="button" size="small" type="primary" v-on:click="open(1, 1)">universal</van-button>
            <van-button slot="button" size="small" type="info" v-on:click="open(1, 2)">scheme</van-button>
          </div>
        </van-field>
      </van-cell-group>
    </section>
    <section class="van-doc-demo-block">
      <h2 class="van-doc-demo-block__title">打开房间</h2>
      <van-cell-group>
        <van-field
          :value="roomId"
          center
          clearable
          label="房间ID"
          :border="false"
          use-button-slot>
          <div class="button-box" slot="button">
            <van-button slot="button" size="small" type="primary" v-on:click="open(2, 1)">universal</van-button>
            <van-button slot="button" size="small" type="info" v-on:click="open(2, 2)">scheme</van-button>
          </div>
        </van-field>
      </van-cell-group>
    </section>
    <section class="van-doc-demo-block">
      <h2 class="van-doc-demo-block__title">打开webview</h2>
      <van-cell-group>
        <van-field
          :value="url"
          center
          clearable
          label="地址URL"
          :border="false"
          use-button-slot>
          <div class="button-box" slot="button">
            <van-button slot="button" size="small" type="primary" v-on:click="open(3, 1)">universal</van-button>
            <van-button slot="button" size="small" type="info" v-on:click="open(3, 2)">scheme</van-button>
          </div>
        </van-field>
      </van-cell-group>
    </section>
    <iframe v-if="link" class="iframe" :src="link"></iframe>
  </div>
</template>

<script>
  import { CellGroup, Cell, Field, Button, RadioGroup, Radio } from 'vant'

  export default {
    name: 'sy_link',
    data () {
      return {
        roomId: 10010,
        url: 'https://mp-cdn.le.com/web/sy/zjd',
        appType: 1,  // 1为Bee语音，2为乐视视频语音版
        link: ''
      }
    },
    mounted () {

    },
    components: {
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [Field.name]: Field,
      [Button.name]: Button,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio
    },
    methods: {
      open (action, type) {
        if (type === 1) {
          const domain = window.location.host.match(/mp-cdn/) ? 'mp.le.com' : 'mp-cdn.le.com'
          let url = `https://${domain}/web/sy/unlink?action=${action}&from=h5`
          switch (action) {
            case 1:
              break
            case 2:
              url = `${url}&roomid=${this.roomId}`
              break
            case 3:
              url = `${url}&url=${encodeURIComponent(this.url)}`
              break
          }
          window.location.href = url
        } else if (type === 2) {
          const scheme = this.appType === 1 ? 'beeclient' : 'letvbee'
          let url = `${scheme}://action?action=${action}&from=h5`
          switch (action) {
            case 1:
              break
            case 2:
              url = `${url}&roomid=${this.roomId}`
              break
            case 3:
              url = `${url}&url=${encodeURIComponent(this.url)}`
              break
          }
          this.link = url
        }
      },
      toggle (index) {
        this.$refs.checkboxes[index].toggle()
      }
    }
  }
</script>

<style>
  html, body, #app {
    height: 100%;
  }

  .wrapper {
    min-height: 100%;
    overflow: hidden;
    background: #f8f8f8;
    font-size: 14px;
  }

  .van-nav-bar {
    position: relative;
    height: 46px;
    line-height: 46px;
    text-align: center;
    background-color: #fff;
    -webkit-user-select: none;
    user-select: none;
  }

  .van-doc-demo-block__title {
    margin: 0;
    padding: 35px 15px 15px;
    color: rgba(69, 90, 100, 0.6);
    font-weight: normal;
    font-size: 14px;
  }

  .button-box .van-button--small:not(:last-child), .button-box .van-button--normal:not(:last-child) {
    margin-right: 10px;
  }

  .iframe {
    display: none;
  }
</style>
